import { useMutateEntry } from '@utils/component-framework';
import { bringItemToFront } from './utils/bring-item-to-front.js';
import { getItemEntryById } from './utils/get-item-by-id.js';
import { getPageEntryById } from './utils/get-page-by-id.js';

function useMoveItemEntryMutation(entryKey) {
  const mutater = useMutateEntry(entryKey);
  return args => mutater(entry => {
    const page = getPageEntryById(entry.data, args.pageId);
    const item = getItemEntryById(page, args.itemId);
    item.position = args.position;
    bringItemToFront(page, item);
    return entry;
  });
}

export { useMoveItemEntryMutation };
//# sourceMappingURL=item.move.js.map
